import * as yup from 'yup';
import { validateSsn } from '../../../helpers/formHelpers/formHelpers';

//validates the refund form and sets the initial values

export interface IRefund {
	IdentificationNumber: string;
	AccountBank: string;
	AccountType: string;
	AccountNumber: string;
	AccountIdentificationNumber: string;
}

export const refundInitialValues: IRefund = {
	IdentificationNumber: '',
	AccountBank: '',
	AccountType: '',
	AccountNumber: '',
	AccountIdentificationNumber: '',
};

export const refundSchema = yup.object().shape({
	AccountIdentificationNumber: yup.string().when('payerIsForeign', {
		is: false,
		then: yup
			.string()
			.required('registerShipment:shared.required')
			.test('is-valid-ssn', 'registerShipment:step-info.ssn-valid', validateSsn),
	}),
	AccountBank: yup.string().when('payerIsForeign', {
		is: false,
		then: yup
			.string()
			.max(4, 'registerShipment:step-info.max')
			.matches(/^[0-9]+$/, 'registerShipment:shared.onlyNumbers')
			.required('registerShipment:shared.required'),
	}),
	AccountType: yup
		.string()
		.matches(/^[0-9]+$/, 'registerShipment:shared.onlyNumbers')
		.when('payerIsForeign', {
			is: false,
			then: yup
				.string()
				.required('registerShipment:shared.required')
				.test(
					'length',
					'registerShipment:step-optional-services.account-type-length',
					val => val && val.length === 2
				),
		}),
	AccountNumber: yup.string().when('payerIsForeign', {
		is: false,
		then: yup
			.string()
			.max(6, 'registerShipment:step-info.max')
			.matches(/^[0-9]+$/, 'registerShipment:shared.onlyNumbers')
			.required('registerShipment:shared.required'),
	}),
});
